import React from 'react';
import pt from 'prop-types';
import { MrInputRadio, MrInputRadioGroup } from '@ion/components';
import GpcCodesMultiSelect from './GpcCodesMultiSelect';
import { CONSENT_GPC_ENABLED } from 'app/components/analytics-builder/form-keys';

export default function ConsentGlobalPrivacyControl({ formState, setField, resetError }) {
  const isEnabled = formState[CONSENT_GPC_ENABLED]?.value === 'true';

  return (
    <div>
      <MrInputRadioGroup
        overrideValue={formState[CONSENT_GPC_ENABLED]?.value ?? 'false'}
        name={CONSENT_GPC_ENABLED}
        label="Global Privacy Control"
        helperText="Whether to honor the browser's Global Privacy Control (GPC) signal."
        onChange={setField}
        resetError={resetError}
        required
      >
        <MrInputRadio
          value="false"
          label="Disabled"
          tooltip="Ignore browser Global Privacy Control signals; consent comes only from your consent source."
        />
        <MrInputRadio
          value="true"
          label="Enabled"
          tooltip="If a visitor's browser supports GPC and sets navigator.globalPrivacyControl, the selected consent codes are forced to opted-out regardless of the consent source. Browsers that do not support GPC are unaffected."
        />
      </MrInputRadioGroup>
      {isEnabled && <GpcCodesMultiSelect formState={formState} setField={setField} />}
    </div>
  );
}

ConsentGlobalPrivacyControl.propTypes = {
  formState: pt.object.isRequired,
  setField: pt.func.isRequired,
  resetError: pt.func.isRequired,
};
